export const MOBILE_APP_VISIT = 'mobile_app_visit';
